define([], function() {
  var strings = {
    "_D2Ups1G4nZEu0oTY7FfRsA": {
      "platformOrApplicationFailedToLoadError": "***{0} or {1} failed to load.",
      "applicationFailedToInitializeError": "***Error initializing application. Error: {0}",
      "applicationFailedToLoadError": "***{0} failed to load. Error: {1}",
      "invalidManifestError": "***Invalid manifest \"{0}\".",
      "invaliPreloadedDataError": "***Invalid preloaded data.",
      "manifestNotFoundError": "***Manifest \"{0}\" not found.",
      "debugManifestLoadingWarning": "***WARNING: This page is requesting to load unsafe scripts, which could potentially harm your computer! Do not proceed unless you trust the developer and understand the risks.\\n\\nIf you are unsure, click \"Cancel.\""
    },
    "_5v0SS2hk3k5Txrl8SXQ7pA": {
      "unableToResolveConfigError": "***Unable to resolve config for module \"{0}\".",
      "invalidFrameworkModuleError": "***Invalid framework module \"{0}\"."
    },
    "_RPELcTeq3ZByqi3N5dt18w": {
      "missingDeveloperToolsTabInitFunctionError": "***Missing component or initializer function.",
      "closeDeveloperToolsAriaLabel": "***Close developer tools."
    },
    "_SxImp5ewsUToxeAHBkB+pw": {
      "developerToolsTabLoadingText": "***Loading...",
      "developerToolsTabLoadingUnknownError": "***Unknown error loading developer tools module."
    },
    "_sovI4qDAUPMnD4jg3Vsyfg": {
      "tabTitle": "***Manifests",
      "noManifestSelected": "***No manifest selected"
    }
  };

  strings.default = strings;
  return strings;
});


//////////////////
// WEBPACK FOOTER
// ../lib/resx-strings/en-us.js
// module id = 1
// module chunks = 0